import styles from './FullScreenDialog.module.scss';

import { FileInput, Box } from '@mantine/core';

import { IconUpload } from '@tabler/icons-react';

import {
  FullScreenDialogAction,
  messageBoxFormValueInit,
  openLinkFormValueInit,
} from '#/components/ui/messages/model';

import { wrapImageUploadProps } from '#/components/ui/messages/MessageEditor/MessageImageUpload';

import { useActionEditorFormContext } from '../../context';

import { makeKFunc, SelectSubAction } from '../utils';
import { OpenLinkFields } from '../OpenLink';
import { MessageBoxFields } from '../MessageBox';

export const FullScreenDialogFields = ({
  keyPrefix,
}: {
  keyPrefix?: string;
}) => {
  const form = useActionEditorFormContext();

  const k = makeKFunc(keyPrefix);

  const type = form.getInputProps(k`type`).value;

  if (type !== 'action_list_dialog') {
    return null;
  }

  const imageFieldOps = wrapImageUploadProps({
    value: form.getInputProps(k`attribute_schema.image`).value,
    setValue: (v) => form.setFieldValue(k`attribute_schema.image`, v),
  });


  const subActionType = form.getInputProps(
    k`attribute_schema.action.type`,
  ).value;


  return (
    <>
      <FileInput
        accept="image/png,image/jpeg"
        placeholder="343x780 px（無比例限制）"
        rightSection={<IconUpload />}
        label="圖片"
        withAsterisk
        value={imageFieldOps.file}
        onChange={(file) => {
          if (!file) return;
          imageFieldOps.upload(file);
        }}
      />
      <SelectSubAction
        label="點擊行為"
        withAsterisk
        key={form.key(k`attribute_schema.action.type`)}
        {...form.getInputProps(k`attribute_schema.action.type`)}
        onChange={(value) => {
          if (value === 'open_link') {
            form.setFieldValue(
              k`attribute_schema.action`,
              openLinkFormValueInit,
            );
          }
          if (value === 'message_box') {
            form.setFieldValue(
              k`attribute_schema.action`,
              messageBoxFormValueInit,
            );
          }
        }}
      />
      <Box pl={10}>
        {subActionType === 'open_link' && (
          <OpenLinkFields keyPrefix={k`attribute_schema.action`} />
        )}
        {subActionType === 'message_box' && (
          <MessageBoxFields keyPrefix={k`attribute_schema.action`} />
        )}
      </Box>
    </>
  );
};

export const FullScreenDialogPreview = ({
  value,
}: {
  value: FullScreenDialogAction;
}) => {
  const imageSrc = value.attribute_schema.image;

  return (
    <div className={styles.preview}>
      <button className={styles.closeBtn} onClick={undefined}>
        ✕
      </button>
      <div className={styles.hero}>
        {imageSrc && <img src={imageSrc} alt="hero placeholder" />}
      </div>
    </div>
  );
};
